/**
 * locastorage class
 * @class UtilLocalstorage
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.localstorage.get('id');
 */
class UtilLocalstorage {
  constructor() {
    this.isSupported = !!window.localStorage;
  }

  /**
   * save to local storage
   * @param {String} key storage key
   * @param {String} val storage value
   */
  set(key, val) {
    localStorage.setItem(key, val);
  }

  /**
   * get value from local storage
   * @param {String} key storage key
   */
  get(key) {
    return localStorage.getItem(key);
  }

  /**
   * delete storage
   * @param {String} key storage key
   */
  del(key) {
    localStorage.removeItem(key);
  }

  /**
   * clear storage
   */
  clear() {
    localStorage.clear();
  }
}

export default new UtilLocalstorage();
